import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './styles/main.scss'
import { polyfill } from 'es6-promise'

polyfill()

ReactDOM.render(<App />, document.getElementById('root'))
